import axiosInstance from '../../../config/axiosInstance';
const  InvoiceService = {
    async GetAllInvoicePayment(redirectCallback,InvoiceID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/GetInvoicePayment?InvoiceID=${InvoiceID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllPaymentMethod(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/GetPaymentMethod`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteInvoicePayment(ID,redirectCallback) {
        try {
           const response = await axiosInstance.get(`/Invoice/DeleteInvoicePayment?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default InvoiceService;